export function codeVisualStyles() {
    return {
        fontFamily: 'Inconsolata, Monaco, monospace',
        fontSize: "3em",
        margin: "0",
        padding: "1em",
        display: 'inline-block'
    };
}
